import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_Mp4ToGifConverter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/mp4-to-gif-converter',
			name: 'MP4 to GIF Converter Online — Create Animated GIFs Instantly by Lift',
			description:
				'Convert MP4 to GIF online — upload your MP4 file and Lift creates an animated GIF in seconds. High quality, no software needed. Try Lift now!',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/mp4-to-gif-converter#product' },
				{ '@id': 'https://liftapp.ai/mp4-to-gif-converter#howto' },
				{ '@id': 'https://liftapp.ai/mp4-to-gif-converter#faq' },
				{ '@id': 'https://liftapp.ai/mp4-to-gif-converter#why-lift' },
				{ '@id': 'https://liftapp.ai/mp4-to-gif-converter#explore-tools' },
				{ '@id': 'https://liftapp.ai/mp4-to-gif-converter#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/mp4-to-gif-converter#product',
			name: 'MP4 to GIF Converter Online',
			description:
				'Convert MP4 files to animated GIF. Upload your MP4 video, choose GIF as output, and download your animated GIF in seconds.',
			url: 'https://liftapp.ai/mp4-to-gif-converter',
			fileFormat: [
				'image/gif',
				'video/mp4',
				'video/quicktime',
				'video/x-msvideo',
				'video/webm',
				'video/x-matroska',
			],
			memoryRequirements: 'Max file size: 2GB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/mp4-to-gif-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload Your MP4 File',
					text: 'Drop in your MP4 file or any other supported video format — MOV, AVI, MKV, WEBM, FLV, and more.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose GIF as Output',
					text: 'Select GIF from dozens of output formats — or choose any other video or audio format you need.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Lift Creates Your GIF',
					text: 'Lift processes your MP4 with high-fidelity encoding, preserving animation smoothness and visual quality.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download the GIF',
					text: 'Your animated GIF is ready instantly — download it for sharing, messaging, social media, or embedding.',
				},
			],
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/mp4-to-gif-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is the Lift MP4 to GIF Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift MP4 to GIF Converter is an online tool that converts MP4 files to animated GIF in seconds. Upload your MP4, choose GIF as output, and download the result.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does the Lift MP4 to GIF Converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Upload your MP4 file, select GIF as the output format, and Lift processes the conversion. Your animated GIF is ready to download in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'How long does MP4 to GIF conversion take?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Most conversions complete in seconds. Processing time depends on file size and length, but Lift is optimized to deliver results as fast as possible.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will the GIF maintain visual quality?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift uses high-fidelity encoding to preserve animation smoothness and visual quality when converting MP4 to GIF.',
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe to convert files with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift prioritizes your privacy — all files are processed securely and are not stored or shared after conversion. Your converted result is available only to you.',
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/mp4-to-gif-converter#why-lift',
			name: "Why Lift's MP4 to GIF Converter stands out",
			description:
				'High-quality animated GIFs, intelligent encoding, cross-platform support, and budget-friendly pricing — Lift delivers professional-grade GIF creation.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality GIFs',
					description:
						'AI-powered technology delivers smooth, high-quality animated GIFs every time.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent encoding',
					description:
						'AI tailors the conversion to the source MP4 for optimal GIF output.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description:
						'Available on iOS, Android, and Web for seamless access.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly software with an affordable and intuitive tool.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/images/mp4-to-gif-converter/whyLift.webp',
				name: 'Lift MP4 to GIF Converter delivering high-quality animated GIFs',
				description: "Lift's online MP4 to GIF converter in high resolution.",
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/mp4-to-gif-converter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/mp4-to-gif-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'MP4 to GIF Converter',
					item: 'https://liftapp.ai/mp4-to-gif-converter',
				},
			],
		},
	],
};
